import { render } from "./FormComi.vue?vue&type=template&id=ba906f1e&scoped=true"
import script from "./FormComi.vue?vue&type=script&lang=js"
export * from "./FormComi.vue?vue&type=script&lang=js"

import "@vueform/slider/themes/default.css?vue&type=style&index=0&lang=css"
import "./FormComi.vue?vue&type=style&index=1&id=ba906f1e&lang=scss&scoped=true"

import exportComponent from "C:\\wamp2022\\www\\emotivapp\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba906f1e"]])

export default __exports__